import { LoadableLazy } from '@confluence/loadable';

export const RequestAccessPopupComponent = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RequestAccessPopup" */ './RequestAccessPopup.tsx'))
			.RequestAccessPopupComponent,
});
